export default {
  switch: '选择产品',
  accountCenter: '账号中心',
  interviewInvitation: '面试邀请',
  companyManagement: '企业管理',
  error403: '无权限访问',
  error404: '页面未找到',
  termsOfService: '服务条款',
  login: '登录',
  forgotPassword: '忘记密码',
  resetPassword: '重置密码'
};
